export const TYPE_LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const TYPE_LOGOUT = "LOGOUT";
export const TYPE_RELOAD_USER = "RELOAD_USER";
export const TYPE_SAVE_PROFILE = "SAVE_PROFILE";
export const TYPE_LOAD_PROFILE = "LOAD_PROFILE";



export const onSuccessLogin = (payload) => (dispatch) => {
    dispatch({type: TYPE_LOGIN_SUCCESS, payload});
}


export const onCompleteLogout = () => (dispatch) => {
    dispatch({type: TYPE_LOGOUT});
}


export const reloadUser = () => (dispatch) =>{
     dispatch({type: TYPE_RELOAD_USER});
}

export const onSaveProfile = (payload) => (dispatch) => {
    dispatch({type: TYPE_SAVE_PROFILE, payload});
}

